import Popup from "@/ts/Popup/Popup";


export default class StoryPopup  extends Popup{

}
